import { Component, OnInit, ViewContainerRef, ViewChild } from '@angular/core';
import { CapacityModelService } from "./../services/CapacityModel-Service";
import { ResponseMsg } from "./../common/response-message";
import { ActivatedRoute, Router } from "@angular/router";
import { ValidateDataService } from "./../services/validate-data.service";
import { RolePayCurveMappingData } from "./../models/cm-model";
import { AuthHelper } from './../services/authHelper';
import {
  SohoModalDialogService, SohoBusyIndicatorDirective,
  SohoMessageRef, SohoNotificationService
} from "ids-enterprise-ng";
import { DatePipe } from '@angular/common';
import { UserData } from '../shared/models/user.model';

@Component({
  selector: 'app-add-role-pay-curve-mapping',
  templateUrl: './add-role-pay-curve-mapping.component.html',
  styleUrls: ['./add-role-pay-curve-mapping.component.css'],
  providers: [DatePipe]
})
export class AddRolePayCurveMappingComponent implements OnInit {
  dialog!: SohoMessageRef;
  @ViewChild(SohoBusyIndicatorDirective, { static: true }) busyIndicator?: SohoBusyIndicatorDirective;

  isvalid!: boolean;
  public getTodaysDate!: Date;
  public getDate?: string;
  emailAddress!: string;
  userData = new UserData();
  message = 'Saving...';
  delay = 5;
  transparentOverlay = true;

  public ProjectTitle = "Add Mapping";

  constructor(private capacityModelService: CapacityModelService,
    private validateService: ValidateDataService,
    public model: RolePayCurveMappingData,
    private modalDialog: SohoModalDialogService,
    private router: Router,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private authhelper: AuthHelper,
    private notificationService: SohoNotificationService) { }

  ngOnInit(): void {
    Soho.Locale.set('en-US');
    this.showNotification();
    this.userData = JSON.parse(localStorage.getItem("userprofile")!);
    if (this.userData != null && this.userData != undefined) {
      this.emailAddress = this.userData.Email;
    }
  }

  showNotification() {
    this.notificationService.show({
      parent: "#notification",
      message: "This page is used to add a new mapping.",
      type: "info",
      linkText: "",
      link: "",
    });
    this.getTodaysDate = new Date();
    this.getDate = this.datePipe.transform(new Date(), 'MM/dd/yyyy')!;
  }
  start() {
    (this.busyIndicator as any).activated = true;
  }
  stop() {
    (this.busyIndicator as any).activated = false;
  }
  RemoveError(id: string) {
    $("#" + id).removeMessage().removeError();
  }
  Cancel() {
    this.router.navigate(["RolePayCurveMapping"]);
  }
  ShowAlert(Message: string, Title: string, navigateBack: boolean = false) {
    const dialogRef1 = this.modalDialog
      .message("<h2>" + Message + "</h2>")
      .buttons(
        [
          {
            text: 'Ok', click: () => {
              dialogRef1.close('Ok');
              if (navigateBack) {
                this.router.navigate(["RolePayCurveMapping"]);
              }
            }, isDefault: true
          }
        ])
      .title(Title)
      .open()
      .frameHeight(1000);
  }
  ResetModel() {
    let fields: string[] = ['roletype', 'paycurve1', 'paycurve2', 'paycurve3', 'paycurve4', 'paycurve5'];
    for (let objField of fields) {
      $("#" + objField).removeError();
    }
    this.model.roletype = "";
    this.model.paycurve1 = "";
    this.model.paycurve2 = "";
    this.model.paycurve3 = "";
    this.model.paycurve4 = "";
    this.model.paycurve5 = "";
  }

  // Pay curve columns are individually optional, but a mapping is meaningless
  // unless at least one of them is filled in.
  HasAtLeastOnePayCurve(): boolean {
    let payCurves: string[] = [
      this.model.paycurve1,
      this.model.paycurve2,
      this.model.paycurve3,
      this.model.paycurve4,
      this.model.paycurve5
    ];
    return payCurves.some(payCurve => payCurve != null && payCurve.toString().trim() != "");
  }

  SaveMapping() {
    this.model.createdby = this.emailAddress == null ? "" : this.emailAddress;
    this.isvalid = true;
    let errorFields: string[];
    errorFields = [];
    errorFields = this.validateService.validateFormFields(this.model, ['roletype']);

    if (errorFields.length > 0) {
      for (let objField of errorFields) {
        $("#" + objField)
          .removeError()
          .addError({ message: ResponseMsg.Required, showTooltip: true });
        this.isvalid = false;
      }
    }
    if (this.isvalid && !this.HasAtLeastOnePayCurve()) {
      this.ShowAlert("At least one pay curve is required.", "Information");
      this.isvalid = false;
    }
    if (this.isvalid) {
      this.start();
      this.capacityModelService.AddRolePayCurveMapping(this.model).subscribe(
        response => {
          this.stop();
          this.ShowAlert("Mapping added successfully.", ResponseMsg.Success, true);
          this.ResetModel();
        },
        (error: Response) => {
          this.stop();
          this.ShowAlert("Error occurred while adding the mapping.", ResponseMsg.ErrorMsg);
        }
      );
    }
  }
}
